export default "__VITE_ASSET__CHf_kkjj__"